export enum MarkerSelectValue {
  INFORMATIVE = 'INFORMATIVE',
  POSITIVE = 'POSITIVE',
  WARNING = 'WARNING',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
}
